// @flow
import styled from '@emotion/styled';

export const AuthTextUnderline = styled.span`
  background-image: linear-gradient(94.47deg, #F42E18 -3.29%, #5C92FF 67.67%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;
